/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'

import TopBar from '../../../components/TopBar';
// import Nestable from 'react-nestable';

import rightLongArrow from '../../../assets/images/right-long-arrow.svg'
import down from '../../../assets/images/icondropdown.svg'
import link from '../../../assets/images/link.svg'
import search from '../../../assets/images/search.svg'
import iconDropDown from "../../../assets/images/icondropdown.svg";
import deleteIcon from '../../../assets/images/delete.svg'

import styles from '../page.module.css'
import AddMenu from '../../../components/Menus/AddMenu';
import DeleteMenuPopup from '../../../components/Menus/DeleteMenuPopup';

import { getMenus, createMenu, updateMenu, getItemList} from '../../../api/menusApi';

const Menus = () => {
    const checkboxesRef = useRef({});
    const popupRef = useRef();
    const addMenuPopupRef = useRef();
    const [showBlock, setshowBlock] = useState('page')
    const [pageSearchInput, setPageSearchInput] = useState('');
    const [productSearchInput, setProductSearchInput] = useState('');
    const [productCategorySearchInput, setProductCategorySearchInput] = useState('');
    const [customLinkTitle, setCustomLinkTitle] = useState('')
    const [customLinkURL, setCustomLinkURL] = useState('')

    const [selectedMenu, setSelectedMenu] = useState();
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const deleteMenuPopupRef = useRef();

    const [originalPages, setOriginalPages] = useState([]);
    const [pagesList, setPagesList] = useState([])    
    const [selectedPagesArray, setSelectedPagesArray] = useState([])

    const [originalProducts, setOriginalProducts] = useState([]);
    const [productList, setProductList] = useState([]);
    const [selectedProductsArray, setSelectedProductsArray] = useState([]);

    const [originalProductCategory, setOriginalProductCategory] = useState([]);
    const [productCategoryList, setProductCategoryList] = useState([]);
    const [selectedProductCategoryArray, setSelectedProductCategoryArray] = useState([]);

    const [searchActive, setSearchActive] = useState(true)
    const [menuList, setMenuList] = useState([]);
    const [showAddInput, setShowAddInput] = useState(false);
    const [newMenuName, setNewMenuName] = useState("");
    const [error, setError] = useState("");
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const [menu, setMenu] = useState([]);
    const itemRefs = useRef([]);
    const dragIndexRef = useRef(null);
    const placeholderIndexRef = useRef(null);
    const draggedItemsRef = useRef([]);
    const startXRef = useRef(0);
    const depthRef = useRef(0);
    const containerRef = useRef(null);
    const isPotentialDragRef = useRef(false);
    const visualPlaceholderRef = useRef(null);

    const loadMenus = async () => {
        try {
            setIsLoading(true);

            const response = await getMenus();

            if (response?.data?.length > 0) {
                setMenuList(response.data);
                const mainMenus = response.data.filter(m => m.title === "Main Menu");

                setSelectedMenu(mainMenus[0]); // default select first
                if (response?.data[0]?.menuItem) {
                    setMenu(response.data[0].menuItem || []);
                } else {
                    setMenu([]);
                }
            }

             const responseList = await getItemList();

             const pageList = responseList?.data?.pages || [];
             const productsList = responseList?.data?.products || [];
             const productCatgoriesList = responseList?.data?.productCategories || [];

             setOriginalPages(pageList)
             setPagesList(pageList.slice(0,4))

             setOriginalProducts(productsList)
             setProductList(productsList.slice(0,4))

             setOriginalProductCategory(productCatgoriesList)
             setProductCategoryList(productCatgoriesList.slice(0,4))

        } catch (error) {
            console.error('Failed to load menus', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadMenus();
    }, []);

    useEffect(() => {
        if (selectedMenu) {
            setMenu(selectedMenu?.menuItem || []);

            const menuItems = selectedMenu?.menuItem || [];

            const pagesItem = menuItems.filter(item => item.type === "page");
            const productCatsItem = menuItems.filter(item => item.type === "product_cat");
            const productsItem = menuItems.filter(item => item.type === "product");

            setSelectedPagesArray(pagesItem);
            setSelectedProductsArray(productsItem);
            setSelectedProductCategoryArray(productCatsItem);
        }
    }, [selectedMenu]);

    const handleSaveMenuToServer = async () => {
        // Check menu exists
        if (!selectedMenu || !selectedMenu.menuId) {
            console.warn('No active menu selected');
            return;
        }

        try {
            setIsLoading(true);

            await updateMenu(selectedMenu.menuId, {
                title: selectedMenu.title,
                menuItem: menu,
            });

        } catch (error) {
            console.error('Failed to save menu', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveMenu = async () => {
        if (!newMenuName.trim()) {
            setError("Menu name is required");
            return;
        }

        try {
            setIsLoading(true);

            // CREATE MENU WITH EMPTY ITEMS
            const response = await createMenu({
                title: newMenuName.trim(),
                menuItem: [],
            });

            // Make this new menu active
            if (response?.data) {
                setMenuList(prev => [...prev, response.data]);
                setSelectedMenu({
                    id: response.data.menuId || response.data.id,
                    title: response.data.title,
                    menuItem: response.data.menuItem || [],
                });

                // reset menu items UI
                setMenu([]);
            }

            // reset popup state
            setNewMenuName("");
            setError("");
            setShowAddInput(false);
        } catch (error) {
            console.error("Failed to create menu", error);
            setError(error?.response?.data?.error?.message || "Failed to create menu");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setOpen(false);
            }
            if (addMenuPopupRef.current && !addMenuPopupRef.current.contains(event.target)) {
                setShowAddInput(false);
            }

            if (deleteMenuPopupRef.current && !deleteMenuPopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
        };

        // Attach the event listener when the component mounts
        document.addEventListener("mousedown", handleClickOutside);

        // Detach the event listener when the component unmounts
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    function searchPages(e) {
        setPageSearchInput(e.target.value)
        setSearchActive(true)
        var result = [];
        var input = e.target.value.toLowerCase()


        originalPages.forEach(element => {
            var title = element.title.toLowerCase();

            if (title) {
                if (title.startsWith(input) === true) {
                    result.push(element)
                }
            }
        });

        if (result.length === originalPages.length) {
            var pages = originalPages.slice(0, 5)
            setPagesList(pages)

        } else if (result != []) {
            setPagesList(result)
            setSearchActive(false)
        } else {
            setPagesList([])
        }
    }

    function searchProducts(e) {
        setProductSearchInput(e.target.value)
        setSearchActive(true)
        var result = [];
        var input = e.target.value.toLowerCase()

        originalProducts.forEach(element => {
            var title = element.title.toLowerCase();

            if (title) {
                if (title.startsWith(input) === true) {
                    result.push(element)
                }
            }
        });

        if (result.length === originalProducts.length) {
            var pages = originalProducts.slice(0, 5)
            setProductList(pages)

        } else if (result != []) {
            setProductList(result)
            setSearchActive(false)
        } else {
            setProductList([])
        }
    }

    function searchProductCategory(e) {
        setProductCategorySearchInput(e.target.value)
        setSearchActive(true)
        var result = [];
        var input = e.target.value.toLowerCase()


        originalProductCategory.forEach(element => {
            var title = element.title.toLowerCase();

            if (title) {
                if (title.startsWith(input) === true) {
                    result.push(element)
                }
            }
        });

        if (result.length === originalProductCategory.length) {
            var pages = originalProductCategory.slice(0, 5)
            setProductCategoryList(pages)

        } else if (result != []) {
            setProductCategoryList(result)
            setSearchActive(false)
        } else {
            setProductCategoryList([])
        }
    }

    const selectedStateMap = {
        page: setSelectedPagesArray,
        product: setSelectedProductsArray,
        product_cat: setSelectedProductCategoryArray,
    };

    const handlePages = (item) => {
        const index = menu.findIndex(
            m => m.id === item.id && m.type === 'page'
        );

        if (index !== -1) {
            // Remove from menu
            removeMenuItemWithChildren(index, 'page');

            // Get parent + children
            const subtree = getSubtree(menu, index);
            const itemsToRemove = subtree.map(i => ({
                id: i.id,
                type: i.type
            }));

            // Remove from selectedItemTypeArray
            itemsToRemove.forEach(({ id, type }) => {
                const setSelected = selectedStateMap[type];
                if (!setSelected) return;

                setSelected(prev =>
                    prev.filter(item => !(item.id === id && item.type === type))
                );
            });
        } else {
            addMenuItem(item);
            setSelectedPagesArray(prev => [...prev, item]);
        }
    };

    const handleProducts = (item) => {
        const index = menu.findIndex(
            m => m.id === item.id && m.type === 'product'
        );

        if (index !== -1) {
            // Remove from menu
            removeMenuItemWithChildren(index, 'product');

             // Get parent + children
            const subtree = getSubtree(menu, index);
            const itemsToRemove = subtree.map(i => ({
                id: i.id,
                type: i.type
            }));

            // Remove from selectedItemTypeArray
            itemsToRemove.forEach(({ id, type }) => {
                const setSelected = selectedStateMap[type];
                if (!setSelected) return;

                setSelected(prev =>
                    prev.filter(item => !(item.id === id && item.type === type))
                );
            });
        } else {
            addMenuItem(item);
            setSelectedProductsArray(prev => [...prev, item]);
        }
    };

    const handleProductCategories = (item) => {
        const index = menu.findIndex(
            m => m.id === item.id && m.type === 'product_cat'
        );

        if (index !== -1) {
            // Remove from menu
            removeMenuItemWithChildren(index, 'product_cat');

            // Get parent + children
            const subtree = getSubtree(menu, index);
            const itemsToRemove = subtree.map(i => ({
                id: i.id,
                type: i.type
            }));

            // Remove from selectedItemTypeArray
            itemsToRemove.forEach(({ id, type }) => {
                const setSelected = selectedStateMap[type];
                if (!setSelected) return;

                setSelected(prev =>
                    prev.filter(item => !(item.id === id && item.type === type))
                );
            });
        } else {
            addMenuItem(item);
            setSelectedProductCategoryArray(prev => [...prev, item]);
        }
    };

    const addMenuItem = (item) => {
        setMenu(prev => [
            ...prev,
            {
                id: item.id,
                title: item.title,
                url_address: item.slug,
                type: item.type,
                depth: 0,
                isOpen: false,
                showHighlight: item?.showHighlight
            }
        ]);
    };

    const generateUniqueId = () => {
        // Generate a unique ID based on the current timestamp
        return Date.now().toString();
    };

    const handleAddCustomLink = () => {
        const uniqueId = generateUniqueId();
        const customLinkData = {
            id: uniqueId,
            title: customLinkTitle,
            url_address: customLinkURL,
            type: 'customLink',
            depth: 0,
            isOpen: false,
            showHighlight: false
        };

        setMenu(prev => [...prev, customLinkData]);

        setCustomLinkTitle('');
        setCustomLinkURL('');
    };

    const updateMenuItemUrl = (index, value) => {
        setMenu(prev =>
            prev.map((item, i) =>
            i === index
                ? { ...item, url_address: value }
                : item
            )
        );
    };

    const [dragIndex, setDragIndex] = useState(null);
    const [placeholderIndex, setPlaceholderIndex] = useState(null);
    const [dragY, setDragY] = useState(0);

    const MAX_DEPTH = 1;
    const INDENT = 30;
    const ROW_HEIGHT = 57;
    const DRAG_THRESHOLD = 5;

    const toggleAccordion = (index) => {
        setMenu(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, isOpen: !item.isOpen } : item
            )
        );
    };

    const updateTitle = (index, value) => {
        setMenu(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, title: value } : item
            )
        );
    };

    const removeMenuItemWithChildren = (index, type) => {
        setMenu(prev => {
            const rootDepth = prev[index].depth;

            let end = index + 1;
            while (end < prev.length && prev[end].depth > rootDepth) {
                end++;
            }

            return prev.filter((item, i) => {
                // remove parent
                if (i === index && item.type === type) return false;

                // remove children of this subtree (same type OR mixed types)
                if (i > index && i < end) return false;

                return true;
            });
        });
    };

    const deleteMenuItem = (index, type) => {
        // Remove from menu (parent + children)
        removeMenuItemWithChildren(index, type);

         // Get parent + children
        const subtree = getSubtree(menu, index);
        const itemsToRemove = subtree.map(i => ({
            id: i.id,
            type: i.type
        }));

        // Remove from selectedItemTypeArray
        itemsToRemove.forEach(({ id, type }) => {
            const setSelected = selectedStateMap[type];
            if (!setSelected) return;

            setSelected(prev =>
                prev.filter(item => !(item.id === id && item.type === type))
            );
        });
    };

    const getSubtree = (list, index) => {
        const rootDepth = list[index].depth;
        const items = [list[index]];

        for (let i = index + 1; i < list.length; i++) {
            if (list[i].depth <= rootDepth) break;
                items.push(list[i]);
        }
        return items;
    };

    const getMaxAllowedDepth = (insertIndex) => {
        if (insertIndex === 0) return 0;

        let maxDepth = 0;

        for (let i = insertIndex - 1; i >= 0; i--) {
            const item = menu[i];

            // Skip dragged subtree
            if (
            dragIndexRef.current !== null &&
            i >= dragIndexRef.current &&
            i < dragIndexRef.current + draggedItemsRef.current.length
            ) {
                continue;
            }

            maxDepth = item.depth + 1;
            break;
        }

        return Math.min(maxDepth, MAX_DEPTH);
    };

    const getPlaceholderHeight = () =>
        (draggedItemsRef.current.length * ROW_HEIGHT) + ((draggedItemsRef.current.length -1 ) * 10 ) ;

    /* ---------- DRAG EVENTS ---------- */
    const handleMouseDown = (e, index) => {
        e.preventDefault();

        dragIndexRef.current = index;
        placeholderIndexRef.current = index;
        draggedItemsRef.current = getSubtree(menu, index);
        depthRef.current = menu[index].depth;
        startXRef.current = e.clientX;

        setDragIndex(index);
        setPlaceholderIndex(index);
        setDragY(e.clientY);

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    const handleRowMouseDown = (e, index) => {
        isPotentialDragRef.current = false;

        const startX = e.clientX;
        const startY = e.clientY;

        const onMove = (moveEvent) => {
            const dx = Math.abs(moveEvent.clientX - startX);
            const dy = Math.abs(moveEvent.clientY - startY);

            if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
            isPotentialDragRef.current = true;
            handleMouseDown(e, index);
            cleanupRowListeners();
            }
        };

        const onUp = () => cleanupRowListeners();

        const cleanupRowListeners = () => {
            document.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseup", onUp);
        };

        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onUp);
    };

    const handleMouseMove = (e) => {
        setDragY(e.clientY);

        // Get container position safely
        const containerRect = containerRef.current?.getBoundingClientRect();
        if (!containerRect) return;

        // Top relative to container
        const relativeY = e.clientY - containerRect.top;

        setDragY(relativeY);

        let newPlaceholder = menu.length;

        for (let i = 0; i < itemRefs.current.length; i++) {
            // Skip dragged subtree
            if (
                dragIndexRef.current !== null &&
                i >= dragIndexRef.current &&
                i < dragIndexRef.current + draggedItemsRef.current.length
            ) {
                continue;
            }

            const el = itemRefs.current[i];
            if (!el) continue;

            const rect = el.getBoundingClientRect();
            if (e.clientY < rect.top + rect.height / 2) {
                newPlaceholder = i;
                break;
            }
        }

        placeholderIndexRef.current = newPlaceholder;
        visualPlaceholderRef.current = newPlaceholder;
        setPlaceholderIndex(newPlaceholder);

        // Horizontal nesting
        const deltaX = e.clientX - startXRef.current;
        let desiredDepth = depthRef.current;

        if (deltaX > INDENT) {
            desiredDepth++;
            startXRef.current = e.clientX;
        } else if (deltaX < -INDENT) {
            desiredDepth--;
            startXRef.current = e.clientX;
        }

        depthRef.current = clampDepthWithSubtree(desiredDepth, newPlaceholder);
    };

    const getSubtreeDepthSpan = (subtree) => {
        let max = 0;
        subtree.forEach(item => {
            max = Math.max(max, item.depth - subtree[0].depth);
        });
        return max;
    };

    const clampDepthWithSubtree = (desiredDepth, insertIndex) => {
        const subtree = draggedItemsRef.current;
        const subtreeSpan = getSubtreeDepthSpan(subtree);

        const baseAllowed = getMaxAllowedDepth(insertIndex);
        const maxAllowed = Math.min(baseAllowed, MAX_DEPTH - subtreeSpan);

        return Math.max(0, Math.min(desiredDepth, maxAllowed));
    };

    const handleMouseUp = () => {
        const from = dragIndexRef.current;
        const to = placeholderIndexRef.current;

        if (from !== null && to !== null) {
            const updated = [...menu];
            const subtree = draggedItemsRef.current;
            const count = subtree.length;

            updated.splice(from, count);

            let insertAt = to;
            if (to > from) insertAt -= count;

            const visualIndex = visualPlaceholderRef.current;

            const finalDepth = clampDepthWithSubtree(
                depthRef.current,
                visualIndex
            );

            const depthDiff = finalDepth - subtree[0].depth;

            const adjusted = subtree.map((item) => ({
                ...item,
                depth: item.depth + depthDiff,
            }));

            updated.splice(insertAt, 0, ...adjusted);
            setMenu(updated);
        }

        cleanup();
    };

    const cleanup = () => {
        dragIndexRef.current = null;
        placeholderIndexRef.current = null;
        draggedItemsRef.current = [];

        setDragIndex(null);
        setPlaceholderIndex(null);

        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
    };

    const handleMenuSelect = (menu) => {
        setSelectedMenu({menuId: menu.menuId, title: menu.title, menuItem: menu?.menuItem || []});
        setOpen(false);
    };

    const confirmDeleteMenu = () => {
        if (!selectedMenu) return;

        setMenuList(prev =>
            prev.filter(menu => menu.menuId !== selectedMenu.menuId)
        );

        setSelectedMenu({menuId: 1, title: "Main Menu"});
        setShowDeletePopup(false);
    };

    return (
        <>
            <TopBar />
            <div className={styles.settingsMenuList}>
                <div className={styles.menuTop}>
                    <button className='add-btn' onClick={() => {setShowAddInput(true) ; setError("")}}>Add Menu</button>
                    <AddMenu
                        showAddInput={showAddInput}
                        newMenuName={newMenuName}
                        setNewMenuName={setNewMenuName}
                        error={error}
                        handleSaveMenu={handleSaveMenu}
                        setShowAddInput={setShowAddInput}
                        refrence={addMenuPopupRef}
                        setError={setError}
                        styles={styles}
                    />

                    <div className='dropdown-wrapper'>

                        {/* Dropdown Header */}
                        <div className='dropdown-header' onClick={() => setOpen(!open)}>
                            <span className='title'> {selectedMenu?.title ? selectedMenu.title : "Select Menu"}</span>
                            <span className={`arrow ${open ? "rotate" : ""}`}><img src={down} alt='down-arrow'/></span>
                        </div>

                        {/* Dropdown List */}
                        {open && (
                            <div className='dropdown-list' ref={popupRef}>
                                {menuList?.length > 0 && menuList?.map((menu, index) => (
                                    <div key={index} onClick={() => handleMenuSelect(menu)} className='dropdown-item'>
                                        <span>{menu?.title}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.settingsListWrap}>
                    <div className={styles.navLeftList}>
                        <p className={`${styles.settingsMenuBlockTitle} ${styles.titleBottom}`}>
                            Select to add the navigation menu
                        </p>

                        <div className={styles.navigationLeft}>
                            <div className={styles.navigationBlocks}>
                                <p
                                    className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle} ${showBlock === "page" ? "active" : ""
                                        }`}
                                    onClick={(e) =>
                                        showBlock !== "page"
                                            ? setshowBlock("page")
                                            : setshowBlock("")
                                    }
                                >
                                    Pages
                                </p>
                                <motion.div
                                    className=""
                                    initial={{ opacity: 1, height: 0 }}
                                    animate={{
                                        opacity: showBlock === "page" ? 1 : 0,
                                        height: showBlock === "page" ? "auto" : 0,
                                        paddingBottom: showBlock === "page" ? "15px" : 0,
                                    }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <>
                                        <div className={styles.navigationTop}>
                                            <div className={styles.pageSearchInput}>
                                                <input
                                                    type="text"
                                                    name="pages_search"
                                                    id="pages_search"
                                                    placeholder={"Search pages..."}
                                                    value={pageSearchInput}
                                                    onChange={(e) => searchPages(e)}
                                                />
                                                <img src={search} alt="Search" />
                                            </div>
                                        </div>

                                        <div className={styles.settingsMenuPages}>
                                            {pagesList && pagesList.length > 0 ? (
                                                pagesList?.map((item, index) => {
                                                    const isSelected = selectedPagesArray.some(
                                                        (data) => data.id === item.id
                                                    );
                                                    return (
                                                        <div key={index} className={styles.settingsMenuItem}>
                                                            <input
                                                                type="checkbox"
                                                                ref={(el) =>
                                                                    (checkboxesRef.current[item.id] = el)
                                                                }
                                                                id={`menu-item-${item.type}-${item.id}`}
                                                                value={item.id}
                                                                onChange={() => handlePages(item)}
                                                                checked={isSelected}
                                                                {...(item.locked ? { readOnly: 'readOnly' } : {})}
                                                            />
                                                            <label htmlFor={`menu-item-${item.type}-${item.id}`}>
                                                                {item.title}
                                                            </label>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p className={styles.nothingFound}>Nothing found!</p>
                                            )}

                                            {searchActive === true && pagesList && originalPages && (pagesList.length !== originalPages.length) ? (
                                                pagesList.length < originalPages.length ? (
                                                    <p
                                                        className={styles.showMorePages}
                                                        onClick={(e) => {
                                                            setPagesList(originalPages);
                                                        }}
                                                    >
                                                        Show {originalPages?.length - pagesList?.length}{" "}
                                                        more
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="showMorePages"
                                                        onClick={(e) => {
                                                            setPagesList(originalPages.slice(0, 5));
                                                        }}
                                                    >
                                                        Hide
                                                    </p>
                                                )
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </>
                                </motion.div>
                            </div>

                            <div className={styles.navigationBlocks}>
                                <p
                                    className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle} ${showBlock === "products" ? "active" : ""}`}
                                    onClick={() => setshowBlock(showBlock !== "products" ? "products" : "")}
                                >
                                    Products
                                </p>

                                <motion.div
                                    initial={{ opacity: 1, height: 0 }}
                                    animate={{
                                        opacity: showBlock === "products" ? 1 : 0,
                                        height: showBlock === "products" ? "auto" : 0,
                                        paddingBottom: showBlock === "products" ? "15px" : 0,
                                    }}
                                >
                                    <>
                                        <div className={styles.navigationTop}>
                                            <div className={styles.pageSearchInput}>
                                                <input
                                                    type="text"
                                                    placeholder="Search products..."
                                                    value={productSearchInput}
                                                    onChange={(e) => searchProducts(e)}
                                                />
                                                <img src={search} alt="Search" />
                                            </div>
                                        </div>

                                        <div className={styles.settingsMenuPages}>
                                            {productList.length > 0 ? (
                                                productList.map((item, index) => {
                                                    const isSelected = selectedProductsArray.some(
                                                        (data) => data.id === item.id
                                                    );
                                                    return (
                                                        <div key={index} className={styles.settingsMenuItem}>
                                                            <input
                                                                type="checkbox"
                                                                id={`menu-item-${item.type}-${item.id}`}
                                                                onChange={() => handleProducts(item)}
                                                                checked={isSelected}
                                                            />
                                                            <label htmlFor={`menu-item-${item.type}-${item.id}`}>{item.title}</label>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p className={styles.nothingFound}>Nothing found!</p>
                                            )}

                                            {searchActive === true && productList && originalProducts && (productList?.length !== originalProducts.length) ? (
                                                productList.length < originalProducts.length ? (
                                                    <p
                                                        className={styles.showMorePages}
                                                        onClick={(e) => {
                                                            setProductList(originalProducts);
                                                        }}
                                                    >
                                                        Show {originalProducts?.length - productList?.length}{" "}
                                                        more
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="showMorePages"
                                                        onClick={(e) => {
                                                            setProductList(originalProducts.slice(0, 5));
                                                        }}
                                                    >
                                                        Hide
                                                    </p>
                                                )
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </>
                                </motion.div>
                            </div>

                            <div className={styles.navigationBlocks}>
                                <p
                                    className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle} ${showBlock === "productCategories" ? "active" : ""}`}
                                    onClick={() =>
                                        setshowBlock(showBlock !== "productCategories" ? "productCategories" : "")
                                    }
                                >
                                    Product Categories
                                </p>

                                <motion.div
                                    initial={{ opacity: 1, height: 0 }}
                                    animate={{
                                        opacity: showBlock === "productCategories" ? 1 : 0,
                                        height: showBlock === "productCategories" ? "auto" : 0,
                                        paddingBottom: showBlock === "productCategories" ? "15px" : 0,
                                    }}
                                >
                                    <>
                                        <div className={styles.navigationTop}>
                                            <div className={styles.pageSearchInput}>
                                                <input
                                                    type="text"
                                                    placeholder="Search product categories..."
                                                    value={productCategorySearchInput}
                                                    onChange={(e) => searchProductCategory(e)}
                                                />
                                                <img src={search} alt="Search" />
                                            </div>
                                        </div>

                                        <div className={styles.settingsMenuPages}>
                                            {productCategoryList.length > 0 ? (
                                                productCategoryList.map((item, index) => {
                                                    const isSelected = selectedProductCategoryArray.some(
                                                        (data) => data.id === item.id
                                                    );
                                                    return (
                                                        <div key={index} className={styles.settingsMenuItem}>
                                                            <input
                                                                type="checkbox"
                                                                id={`menu-item-${item.type}-${item.id}`}
                                                                onChange={() => handleProductCategories(item)}
                                                                checked={isSelected}
                                                            />
                                                            <label htmlFor={`menu-item-${item.type}-${item.id}`}>{item.title}</label>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p className={styles.nothingFound}>Nothing found!</p>
                                            )}

                                            {searchActive === true && productCategoryList && originalProductCategory && originalProductCategory.length > 0 && (productCategoryList?.length !== originalProductCategory.length) ? (
                                                productCategoryList.length < originalProductCategory.length ? (
                                                    <p
                                                        className={styles.showMorePages}
                                                        onClick={(e) => {
                                                            setProductCategoryList(originalProductCategory);
                                                        }}
                                                    >
                                                        Show {originalProductCategory?.length - productCategoryList?.length}{" "}
                                                        more
                                                    </p>
                                                ) : (
                                                    <p
                                                        className="showMorePages"
                                                        onClick={(e) => {
                                                            setProductCategoryList(originalProductCategory.slice(0, 5));
                                                        }}
                                                    >
                                                        Hide
                                                    </p>
                                                )
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </>
                                </motion.div>
                            </div>

                            <div className={`${styles.navigationBlocks} linkAdd`}>
                                <p
                                    className={`${styles.settingsMenuBlockTitle} ${styles.pagesTitle} ${showBlock === "custom" ? "active" : ""
                                        }`}
                                    onClick={(e) =>
                                        showBlock !== "custom"
                                            ? setshowBlock("custom")
                                            : setshowBlock("")
                                    }
                                >
                                    Custom link
                                </p>

                                <motion.div
                                    className=""
                                    initial={{ opacity: 1, height: 0 }}
                                    animate={{
                                        opacity: showBlock === "custom" ? 1 : 0,
                                        height: showBlock === "custom" ? "auto" : 0,
                                    }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <>
                                        <div className={styles.customLinkRow}>
                                            <p>Title</p>
                                            <input
                                                type="text"
                                                placeholder="Type the title"
                                                value={customLinkTitle}
                                                onChange={(e) => setCustomLinkTitle(e.target.value)}
                                            />
                                        </div>

                                        <div className={styles.customLinkRow}>
                                            <p>Paste URL to link</p>
                                            <div className={styles.customLinkWrapper}>
                                                <input className={styles.linkInput} type="text" placeholder="Paste URL to link" value={customLinkURL} onChange={(e) => setCustomLinkURL(e.target.value)}/>
                                                <img className={styles.inputLink} src={link} alt="Link" />
                                            </div>
                                        </div>

                                        <button onClick={(e) => {handleAddCustomLink(e);}} className={`${styles.addToMenu} button`}>
                                            <p>Add</p>
                                            <img src={rightLongArrow} alt="Plus" />
                                        </button>
                                    </>
                                </motion.div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.navigationRight}>
                        <p className={styles.settingsMenuBlockTitle}>My navigation menu</p>

                        <div className={styles.navRightList}>
                            <div className={styles.menuSorter} ref={containerRef}>
                                {menu.length > 0 && menu.map((item, index) => {
                                    const isDraggingSubtree = dragIndex !== null && index >= dragIndex && index < dragIndex + draggedItemsRef.current.length;

                                    return (
                                        <div key={`menu-item-row-${item.type}-${item.id}`} >
                                            {placeholderIndex === index && dragIndex !== null && (
                                                <div className={styles.placeholder}
                                                    style={{
                                                        height: getPlaceholderHeight(),
                                                        marginLeft: depthRef.current > 0 ? depthRef.current * INDENT : 0,
                                                    }}
                                                />
                                            )}
                                            <div className={`${styles.menuItemRow} ${isDraggingSubtree ? styles.hidden : ""}`} style={{ marginLeft: item.depth > 0 ? item.depth * INDENT : 0,}}>
                                                <div
                                                    ref={(el) => (itemRefs.current[index] = el)}
                                                    className={styles.menuItem}
                                                    onMouseDown={(e) => handleRowMouseDown(e, index)}
                                                    onClick={() => {
                                                        if (!isPotentialDragRef.current) {
                                                        toggleAccordion(index);
                                                        }
                                                    }}
                                                    >
                                                   <span
                                                        className={styles.dragIcon}
                                                        onMouseDown={(e) => {
                                                            e.stopPropagation();
                                                            handleMouseDown(e, index);
                                                        }}
                                                        >
                                                        ⇅
                                                    </span>
                                                    <span className={styles.menuTitleFront}> {item.title}</span>
                                                    <button
                                                        className={styles.dropdownToggle}
                                                        onMouseDown={(e) => e.stopPropagation()}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleAccordion(index);
                                                        }}
                                                    >
                                                        <img src={iconDropDown} alt="dropdown" className={`${styles.dropdownIcon} ${ item.isOpen ? styles.rotate : ""}` } />
                                                    </button>
                                                </div>

                                                {item.isOpen && (
                                                    <div className={styles.menuItemEditor} onMouseDown={(e) => e.stopPropagation()}>
                                                        <p className={styles.menuItemTitle}>Title</p>
                                                        <div className={styles.menuItemTextWrap}>
                                                            <input className={styles.menuItemText} type="text" value={item.title} onChange={(e) => updateTitle(index, e.target.value)}/>
                                                        </div>
                                                        
                                                        {item.type === "customLink" &&
                                                            <>
                                                                <p className={styles.menuItemTitle}>Url</p>
                                                                <div className={styles.menuItemTextWrap}>
                                                                    <input type="text"
                                                                        className={styles.menuItemText}
                                                                        placeholder="Enter URL"
                                                                        value={item.url_address || ""}
                                                                        onChange={(e) =>
                                                                            updateMenuItemUrl(index, e.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </>
                                                        }

                                                        <button className={`${styles.deleteMenuItem}`} onClick={() => deleteMenuItem(index, item.type)}> 
                                                            <img className='deleteIconImage' src={deleteIcon} alt="Delete Item" />
                                                            <span>Delete</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}

                                {placeholderIndex === menu.length && dragIndex !== null && (
                                    <div className={styles.placeholder}
                                        style={{
                                            height: getPlaceholderHeight(),
                                            marginLeft:
                                            depthRef.current > 0 ? depthRef.current * INDENT : 0,
                                        }}
                                    />
                                )}

                                {dragIndex !== null && (
                                    <div className={styles.dragPreview} style={{ top: dragY - 28 }}>
                                        {draggedItemsRef.current.map((item, i) => (
                                            <div
                                                key={item.id}
                                                className={styles.dragPreviewItem}
                                                style={{ marginLeft: item.depth * INDENT }}
                                            >
                                                <span className={styles.dragIcon}>⇅</span>
                                                <span className={styles.dragPreviewItemTitle}>{item.title}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {selectedMenu && (
                    <div className={styles.saveButtons}>
                        {selectedMenu.menuId !== 1 && (
                            <button
                                className={`${styles.deleteButton} ${
                                styles.button
                                }`}
                                onClick={() => {
                                    setShowDeletePopup(true);
                                }}
                            >
                                
                                Delete
                            </button>
                        )}

                        <button
                            className={`${styles.saveButton} ${
                            isLoading ? styles.btnLoading : styles.button
                            }`}
                            onClick={handleSaveMenuToServer}
                        >
                            {isLoading ? (
                            <div className='ringLoader'>
                            </div>
                            ) : (
                            "Save"
                            )}
                        </button>
                    </div>
                )}
                
                <DeleteMenuPopup
                    showDeletePopup={showDeletePopup}
                    setShowDeletePopup={setShowDeletePopup}
                    reference={deleteMenuPopupRef}
                    confirmDelete={confirmDeleteMenu}
                    isLoading={isLoading}
                />
            </div>
        </>
    )
}

export default Menus